"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericVideoPlayer = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("../../../utils/utils");
var constants_1 = require("../../../constants/constants");
var sdk_1 = require("../../../sdk/sdk");
var resumeWatchingService_1 = require("../../resumeWatching/resumeWatchingService");
var resumeWatchingStorageRepository_1 = require("../../storage/resumeWatching/resumeWatchingStorageRepository");
/**
 * Implementation of the VideoPlayer interface for a generic video player.
 * @class
 * @implements {VideoPlayer}
 */
var GenericVideoPlayer = /** @class */ (function () {
    function GenericVideoPlayer(config, appConfig, videoInfo, profileId) {
        this.playerInstance = null;
        this.timeUpdateListener = null;
        this.videoInfo = videoInfo;
        this.appConfig = appConfig;
        this.config = config;
        this.profileId = profileId;
    }
    GenericVideoPlayer.prototype.initialize = function () {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var BitmovinPlayer, bitmovinAnalyticsConfig, player, response, error_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, Promise.resolve().then(function () { return tslib_1.__importStar(require('./BitmovinPlayer')); })];
                    case 1:
                        BitmovinPlayer = (_c.sent()).BitmovinPlayer;
                        bitmovinAnalyticsConfig = (_a = this.appConfig.video_analytics) === null || _a === void 0 ? void 0 : _a.find(function (analytics) { return analytics.vendor_name === 'Bitmovin' && analytics.enable; });
                        player = new BitmovinPlayer(this.config, this.appConfig, this.videoInfo, bitmovinAnalyticsConfig);
                        this.player = player;
                        if (!this.player) return [3 /*break*/, 10];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 8, , 9]);
                        return [4 /*yield*/, this.player.initialize()];
                    case 3:
                        response = _c.sent();
                        if (!response) return [3 /*break*/, 6];
                        this.playerInstance = this.player.playerInstance;
                        if (!((_b = sdk_1.VelvetSDK.Configuration.configuration) === null || _b === void 0 ? void 0 : _b.features.resumeWatching.enabled)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.initResumeWatching()];
                    case 4:
                        _c.sent();
                        _c.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        console.error('Player instance not found');
                        _c.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_1 = _c.sent();
                        console.error('Error initializing player:', error_1);
                        return [3 /*break*/, 9];
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        console.error('Player not found');
                        _c.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    GenericVideoPlayer.prototype.destroy = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var duration, currentTime;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.player) return [3 /*break*/, 5];
                        if (!(this.resumeWatchingService && this.playerInstance)) return [3 /*break*/, 3];
                        duration = Math.floor(this.getDuration());
                        currentTime = this.timeUpdateListener ? this.currentTime : Math.floor(this.getCurrentTime());
                        this.removeListeners();
                        return [4 /*yield*/, this.player.destroy()
                            // Save AFTER destroy with pre-captured values (no player dependency)
                        ];
                    case 1:
                        _a.sent();
                        // Save AFTER destroy with pre-captured values (no player dependency)
                        return [4 /*yield*/, this.resumeWatchingService.saveVideoProgress(duration, currentTime)];
                    case 2:
                        // Save AFTER destroy with pre-captured values (no player dependency)
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.player.destroy()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    GenericVideoPlayer.prototype.play = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.player) {
                    this.player.play();
                }
                return [2 /*return*/];
            });
        });
    };
    GenericVideoPlayer.prototype.pause = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.player) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.player.pause()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.saveResumeWatching()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GenericVideoPlayer.prototype.seek = function (time) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.player) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.player.seek(time)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    GenericVideoPlayer.prototype.getCurrentTime = function () {
        if (this.player) {
            return this.player.getCurrentTime();
        }
        else {
            console.error('Player is not initialized. Call initialize() first.');
            return 0;
        }
    };
    GenericVideoPlayer.prototype.getDuration = function () {
        if (this.player) {
            return this.player.getDuration();
        }
        else {
            console.error('Player is not initialized. Call initialize() first.');
            return 0;
        }
    };
    GenericVideoPlayer.prototype.getVideoElement = function () {
        if (this.player) {
            return this.player.getVideoElement();
        }
        else {
            console.error('Player is not initialized. Call initialize() first.');
            return null;
        }
    };
    GenericVideoPlayer.prototype.getPlayerInstance = function () {
        if (this.player) {
            return this.player.playerInstance;
        }
    };
    GenericVideoPlayer.prototype.isLive = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.player) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.player.isLive()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        console.error('Error in isLive(). Player is not initialized');
                        return [2 /*return*/, false];
                }
            });
        });
    };
    GenericVideoPlayer.prototype.on = function (eventType, callback) {
        if (this.player) {
            return this.player.on(eventType, callback);
        }
        else {
            console.error('Error in player event "on". Player is not initialized');
        }
    };
    GenericVideoPlayer.prototype.getSubtitleList = function () {
        if (this.player) {
            return this.player.getSubtitleList();
        }
        else {
            console.error('Error in getSubtitleList(). Player is not initialized');
            return Promise.resolve([]);
        }
    };
    GenericVideoPlayer.prototype.setSubtitle = function (subtitleId) {
        if (this.player) {
            this.player.setSubtitle(subtitleId);
        }
        else {
            console.error('Error in setSubtitle(). Player is not initialized');
        }
    };
    GenericVideoPlayer.prototype.getAudioList = function () {
        if (this.player) {
            return this.player.getAudioList();
        }
        else {
            console.error('Error in getAudioList(). Player is not initialized');
            return Promise.resolve([]);
        }
    };
    GenericVideoPlayer.prototype.getAudio = function () {
        var _a;
        if (this.player) {
            return (_a = this.player.getAudio()) === null || _a === void 0 ? void 0 : _a.id;
        }
        else {
            console.error('Error in getAudio(). Player is not initialized');
            return '';
        }
    };
    GenericVideoPlayer.prototype.setAudio = function (audioId) {
        if (this.player) {
            return this.player.setAudio(audioId);
        }
        else {
            console.error('Error in setAudio(). Player is not initialized');
        }
    };
    GenericVideoPlayer.prototype.isInitialized = function () {
        if (this.player) {
            return this.player.isInitialized();
        }
        else {
            console.error('Error in isInitialized()');
            return false;
        }
    };
    GenericVideoPlayer.prototype.initResumeWatching = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.player) return [3 /*break*/, 3];
                        this.resumeWatchingService = new resumeWatchingService_1.ResumeWatchingService(this.videoInfo, new resumeWatchingStorageRepository_1.ResumeWatchingStorageRepository(), this.profileId);
                        return [4 /*yield*/, this.resumeWatchingService.initialize()];
                    case 1:
                        _b.sent();
                        if (!((_a = this.resumeWatchingService) === null || _a === void 0 ? void 0 : _a.isEnabled)) return [3 /*break*/, 3];
                        this.initListeners();
                        return [4 /*yield*/, this.checkAndSeekToResumePoint()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GenericVideoPlayer.prototype.checkAndSeekToResumePoint = function () {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var videoAlreadyAddedToRW, creditsStartTime, maxWatchedPercentage, percentageVideoWatched, error_2;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 6, , 7]);
                        videoAlreadyAddedToRW = (_a = this.resumeWatchingService) === null || _a === void 0 ? void 0 : _a.resumeWatchingItem;
                        creditsStartTime = (0, utils_1.timeStringToSeconds)(this.videoInfo.contextData.creditsStartTime);
                        maxWatchedPercentage = (_b = sdk_1.VelvetSDK.Configuration.configuration) === null || _b === void 0 ? void 0 : _b.features.resumeWatching.maxWatchedPercentage;
                        if (!maxWatchedPercentage) {
                            throw new Error('Resume watching maxWatchedPercentage is not configured');
                        }
                        if (!(this.player && videoAlreadyAddedToRW && videoAlreadyAddedToRW.watchedDuration)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.player.isInitialized()];
                    case 1:
                        _c.sent();
                        percentageVideoWatched = (0, utils_1.getPercentageVideoWatched)(this.getDuration(), videoAlreadyAddedToRW.watchedDuration);
                        if (!((creditsStartTime && videoAlreadyAddedToRW.watchedDuration > creditsStartTime) ||
                            percentageVideoWatched > maxWatchedPercentage)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.seek(constants_1.PLAY_FROM_BEGINNING)];
                    case 2:
                        _c.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.seek(videoAlreadyAddedToRW.watchedDuration)];
                    case 4:
                        _c.sent();
                        _c.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_2 = _c.sent();
                        console.error('An error ocurred while seeking to resume point: ', error_2);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    GenericVideoPlayer.prototype.saveResumeWatching = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentTime, error_3;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        if (!this.player) return [3 /*break*/, 2];
                        currentTime = this.timeUpdateListener ? this.currentTime : Math.floor(this.getCurrentTime());
                        return [4 /*yield*/, ((_a = this.resumeWatchingService) === null || _a === void 0 ? void 0 : _a.saveVideoProgress(Math.floor(this.getDuration()), currentTime))];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_3 = _b.sent();
                        console.error('Error saving resume watching:', error_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GenericVideoPlayer.prototype.initListeners = function () {
        var _a;
        if (this.player && this.playerInstance && ((_a = this.resumeWatchingService) === null || _a === void 0 ? void 0 : _a.isEnabled)) {
            this.handleErrorListener();
            this.handleTimeUpdateListener();
        }
    };
    GenericVideoPlayer.prototype.removeListeners = function () {
        var _a;
        var htmlVideoElement = this.getVideoElement();
        this.playerErrorListener && ((_a = this.playerInstance) === null || _a === void 0 ? void 0 : _a.off('error', this.playerErrorListener));
        if (htmlVideoElement) {
            this.timeUpdateListener && htmlVideoElement.removeEventListener('timeupdate', this.timeUpdateListener);
        }
    };
    GenericVideoPlayer.prototype.handleErrorListener = function () {
        var _this = this;
        var _a;
        this.playerErrorListener = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.saveResumeWatching()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        (_a = this.playerInstance) === null || _a === void 0 ? void 0 : _a.on('error', this.playerErrorListener);
    };
    GenericVideoPlayer.prototype.handleTimeUpdateListener = function () {
        var _this = this;
        var _a;
        var heartbeat = (_a = sdk_1.VelvetSDK.Configuration.configuration) === null || _a === void 0 ? void 0 : _a.features.resumeWatching.heartbeat;
        if (!heartbeat) {
            throw new Error('Resume watching heartbeat is not configured');
        }
        var htmlVideoElement = this.getVideoElement();
        var isFirstLoad = true;
        var lastSavedTime = 0;
        if (htmlVideoElement && !this.timeUpdateListener) {
            this.timeUpdateListener = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var exactTime;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            exactTime = htmlVideoElement.currentTime;
                            this.currentTime = Math.floor(exactTime);
                            if (isFirstLoad) {
                                lastSavedTime = this.currentTime;
                                isFirstLoad = false;
                                return [2 /*return*/];
                            }
                            if (this.currentTime === lastSavedTime)
                                return [2 /*return*/];
                            lastSavedTime = this.currentTime;
                            if (!(lastSavedTime % heartbeat === 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.saveResumeWatching()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); };
            htmlVideoElement === null || htmlVideoElement === void 0 ? void 0 : htmlVideoElement.addEventListener('timeupdate', this.timeUpdateListener);
        }
        else {
            console.error('Error: Unable to initialize timeupdate listener. Video element is not available."');
        }
    };
    return GenericVideoPlayer;
}());
exports.GenericVideoPlayer = GenericVideoPlayer;
